import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useTheme } from "../../context/ThemeContext";
import TransliteratedInput from "../common/TransliteratedInput";
import AutoSave from "../common/AutoSave";
import { useNavigate } from "react-router-dom";

const PatientCIForm = (props) => {
  const { initialValues, onSubmit, onBack, isFirstStep, isLastStep, onAutoSave } = props;
  const navigate = useNavigate();
  const { theme, isDarkMode } = useTheme();
  console.log(props);

  const patientCIInfo = initialValues.patientClinicalInvestigation?.[0] || {};

  const formInitialValues = {
    PATIENT_NADI: patientCIInfo?.PATIENT_NADI || "",
    PATIENT_GATI: patientCIInfo?.PATIENT_GATI || "",
    PATIENT_JIVA: patientCIInfo?.PATIENT_JIVA || "",
    PATIENT_MAL: patientCIInfo?.PATIENT_MAL || "",
    PATIENT_MUTR: patientCIInfo?.PATIENT_MUTR || "",
    PATIENT_NETRA: patientCIInfo?.PATIENT_NETRA || "",
    PATIENT_HRADAY: patientCIInfo?.PATIENT_HRADAY || "",
    PATIENT_PHUPPUS: patientCIInfo?.PATIENT_PHUPPUS || "",
    PATIENT_NIDRA: patientCIInfo?.PATIENT_NIDRA || "",
    PATIENT_AGNI: patientCIInfo?.PATIENT_AGNI || "",
  };

  const validationSchema = Yup.object().shape({
    PATIENT_NADI: Yup.string(),
    PATIENT_GATI: Yup.string(),
    PATIENT_JIVA: Yup.string(),
    PATIENT_MAL: Yup.string(),
    PATIENT_MUTR: Yup.string(),
    PATIENT_NETRA: Yup.string(),
    PATIENT_HRADAY: Yup.string(),
    PATIENT_PHUPPUS: Yup.string(),
    PATIENT_NIDRA: Yup.string(),
    PATIENT_AGNI: Yup.string(),
  });

  const ciFields = [
    { name: "PATIENT_NADI", label: "Nadi" },
    { name: "PATIENT_GATI", label: "Gati" },
    { name: "PATIENT_JIVA", label: "Jiva" },
    { name: "PATIENT_MAL", label: "Mal" },
    { name: "PATIENT_MUTR", label: "Mutr" },
    { name: "PATIENT_NETRA", label: "Netra" },
    { name: "PATIENT_HRADAY", label: "Hraday" },
    { name: "PATIENT_PHUPPUS", label: "Phuppus" },
    { name: "PATIENT_NIDRA", label: "Nidra" },
    { name: "PATIENT_AGNI", label: "Agni" },
  ];

  return (
    <Formik
      initialValues={formInitialValues}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        onSubmit(values);
        actions.setSubmitting(false);
      }}
      enableReinitialize={true}
    >
      {({ errors, touched, isSubmitting }) => (
        <Form className="space-y-4 md:space-y-6 w-full">
          <AutoSave onAutoSave={(values) => (onAutoSave || onSubmit)?.(values, { isAutoSave: true })} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {ciFields.map((field) => (
              <div key={field.name} className="space-y-2">
                <label
                  htmlFor={field.name}
                  className="block text-sm font-medium transition-colors"
                  style={{ color: theme.text }}
                >
                  {field.label}
                </label>
                <Field name={field.name}>
                  {({ field: formField, form }) => (
                    <TransliteratedInput
                      {...formField}
                      onChangeText={(text) => form.setFieldValue(formField.name, text)}
                      className={`w-full px-4 py-2.5 rounded-lg border transition-all duration-200 focus:outline-none focus:ring-2 ${touched[formField.name] && errors[formField.name]
                        ? 'border-red-500 focus:ring-red-500'
                        : 'focus:ring-opacity-50'
                        }`}
                      style={{
                        backgroundColor: theme.inputBg,
                        borderColor: touched[formField.name] && errors[formField.name] ? '#d63031' : theme.border,
                        color: theme.text,
                      }}
                    />
                  )}
                </Field>
                <ErrorMessage name={field.name} component="div" className="text-red-500 text-sm mt-1" />
              </div>
            ))}
          </div>

          <div
            className="flex justify-between items-center pt-2 mt-4 border-t col-span-full sticky bottom-0 z-[100] py-3 -mx-4 md:-mx-10 lg:-mx-12 px-4 md:px-10 lg:px-12"
            style={{
              borderColor: theme.border,
              backgroundColor: theme.card,
              boxShadow: '0 -4px 10px rgba(0,0,0,0.05)'
            }}
          >
            {!isFirstStep && onBack && (
              <button
                type="button"
                onClick={onBack}
                className="px-4 py-1.5 rounded-full font-semibold transition-all duration-200 hover:scale-105 active:scale-95 text-xs md:text-sm"
                style={{
                  backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                  color: theme.text,
                  border: `1px solid ${theme.border}`
                }}
              >
                Back
              </button>
            )}
            <div className={isFirstStep ? "ml-auto" : ""}>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-6 py-2 rounded-full font-bold text-white transition-all duration-200 hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed text-sm md:text-base shadow-lg animate-flow"
                style={{
                  backgroundImage: `linear-gradient(to right, ${theme.brownTwo}, ${theme.secondary}, ${theme.primary}, ${theme.brownTwo})`,
                }}
              >
                {isLastStep ? "Submit" : "Next"}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default PatientCIForm;
